import type { ReactNode } from "react";
import { Button } from "./Button";
import { buttonClass } from "./Button";

export interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  actionHref?: string;
  onAction?: () => void;
  actionVariant?: "primary" | "outline";
  icon?: ReactNode;
  className?: string;
}

export function EmptyState({
  title,
  description,
  actionLabel,
  actionHref,
  onAction,
  actionVariant = "primary",
  icon,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={`rounded-2xl bg-[color:var(--surface)] px-6 py-8 text-center shadow-[var(--shadow-md)] ${className ?? ""}`}
    >
      {icon ? <div className="mb-3 flex justify-center">{icon}</div> : null}
      <p className="text-sm font-semibold text-[color:var(--text-secondary)]">
        {title}
      </p>
      <p className="mt-2 text-[13px] text-[color:var(--text-muted)]">
        {description}
      </p>
      {actionLabel ? (
        <div className="mt-4 flex justify-center">
          {actionHref ? (
            <a
              href={actionHref}
              className={buttonClass({
                variant: actionVariant,
                size: "md",
              })}
            >
              {actionLabel}
            </a>
          ) : onAction ? (
            <Button
              type="button"
              onClick={onAction}
              variant={actionVariant}
              size="md"
            >
              {actionLabel}
            </Button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
